<div [ngSwitch]="orderConfig?.channel">
  <ng-template [ngSwitchCase]="'STARGAZE'">
    <ion-grid *ngIf="order">
      <ion-row>
        <ion-col size="12">
          <ion-icon [src]="'./assets/paper.svg'"></ion-icon>
          <ion-text font-bold="" text-large="">{{
            order?.formattedId
          }}</ion-text>
          <ion-text *ngIf="!order?.saleOrder" font-regular="" text-large>
            &nbsp;• {{ order?.orderType === "DROP" ? "Drop" : "Pickup" }}
          </ion-text>
          <ion-icon
            *ngIf="
              order.orderType === 'DROP' &&
              order?.payment?.orderPaymentStatus !== 'COMPLETED'
            "
            (click)="onClickRemoveOrder(order?.id)"
            class="ion-float-right pi cursor-pointer"
            name="trash"
          ></ion-icon>
        </ion-col>
        <ion-col style="max-width: 28%">
          <rcyl-customer-details
            [orderType]="order.orderType"
            [saleOrder]="order.saleOrder"
            [location]="
              order?.saleOrder
                ? order?.toLocation
                : order.orderType === 'PICKUP'
                ? order?.fromLocation
                : ''
            "
            [customer]="
              order?.saleOrder
                ? order?.buyer
                : order.orderType === 'PICKUP'
                ? order?.fromLocation
                : order?.seller
            "
          ></rcyl-customer-details>
        </ion-col>
        <ion-col size="3">
          <rcyl-pickup-details
            [selectOrder]="order"
            (changeExecutive)="getOrderDetails()"
          ></rcyl-pickup-details>
        </ion-col>
        <ion-col>
          <rcyl-status-details
            [getConfig]="configData"
            [selectOrder]="order"
            (actionTriggered)="receivedData($event)"
          ></rcyl-status-details>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ion-item lines="none">
            <ion-text class="section-title ion-margin-end"
              >Item Details</ion-text
            >
            <div
              *ngIf="
                (order.orderType === 'PICKUP' &&
                  status(['PICKUP_SCHEDULED'], true) &&
                  !order.saleOrder &&
                  status(
                    [
                      'MATERIAL_RECEIVED',
                      'ORDER_COMPLETED',
                      'MATERIAL_PICKED',
                      'CREATED',
                      'CANCELLED',
                      'REJECTED',
                      'HOLD'
                    ],
                    false
                  )) ||
                (order.orderType === 'DROP' &&
                  order?.payment?.orderPaymentStatus !== 'COMPLETED')
              "
            >
              <rcyl-add-item-button
                (itemSelect)="onItemAdded($event)"
                [params]="{
                  orderItems: order?.orderItems,
                  locationId: order?.toLocation?.id,
                  customerId: order?.seller.id
                }"
              >
              </rcyl-add-item-button>
            </div>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <rcyl-item-details
            [selectOrder]="order"
            (itemUpdated)="onItemChanged($event)"
          ></rcyl-item-details>
        </ion-col>
        <ion-col
          size="12"
          *ngIf="
            (order?.orderType === 'DROP' &&
              order?.status === 'PICKUP_SCHEDULED') ||
            order?.status === 'ORDER_COMPLETED' ||
            order?.documents?.length > 0
          "
        >
          <ion-item lines="none">
            <ion-text class="section-title"
              >View/Upload Supporting Documents</ion-text
            >
            <!--<ion-button class="status-btn ion-margin-start" fill="outline" size="large" color="medium"  (click)="addDocuments()">
                            <ion-text text-regular>View Upload Files</ion-text>
                        </ion-button>-->
          </ion-item>
        </ion-col>
        <ion-col
          size="12"
          class="col-position"
          *ngIf="
            (order?.orderType === 'DROP' &&
              order?.status === 'PICKUP_SCHEDULED') ||
            order?.status === 'ORDER_COMPLETED' ||
            order?.documents?.length > 0
          "
        >
          <ion-grid>
            <ion-row>
              <ion-col
                size="auto"
                *ngFor="
                  let orderTypeData of orderDocumentsMap
                    | rcylFilter: 'showInList':true
                    | rcylKeys
                "
              >
                <ion-chip
                  [outline]="true"
                  [ngClass]="
                    orderTypeData?.val?.documents?.length > 0
                      ? 'docs-chip'
                      : 'no-docs-chip'
                  "
                  (click)="addDocuments(orderTypeData?.key)"
                >
                  <ion-icon [src]="orderTypeData?.val?.icon"></ion-icon>
                  <ion-text
                    text-wrap
                    [color]="
                      orderTypeData?.val?.documents?.length > 0
                        ? 'primary'
                        : 'medium'
                    "
                    class="text-regular text-flex"
                  >
                    {{ orderTypeData?.val?.displayText }}
                  </ion-text>
                  <div
                    color="primary"
                    *ngIf="orderTypeData?.val?.documents?.length > 0"
                  >
                    <ion-text class="text-regular" color="light">{{
                      orderTypeData?.val?.documents?.length
                    }}</ion-text>
                  </div>
                </ion-chip>
              </ion-col>
            </ion-row>
          </ion-grid>
          <!-- <rcyl-view-upload-docs [selectOrderDocuments]="this.order?.documents" [selectOrderStatus]="order?.status"
                                           [selectOrderId]="order?.id" [selectOrderType]="order?.orderType"
                                           (fileUploadEvent)="fileUploaded($event)"
                                           (proformaInvoiceDownload)="viewProformaInvoice($event)"></rcyl-view-upload-docs>-->
        </ion-col>
        <ion-col
          size="12"
          *ngIf="
            order?.payment?.orderPaymentStatus === 'COMPLETED' &&
            order?.status === 'ORDER_COMPLETED'
          "
        >
          <ion-item lines="none">
            <ion-text class="section-title ion-margin-end"
              >Payment Summary</ion-text
            >
          </ion-item>
        </ion-col>
        <ion-col
          size="12"
          *ngIf="
            order?.payment?.orderPaymentStatus === 'COMPLETED' &&
            order?.status === 'ORDER_COMPLETED'
          "
        >
          <rcyl-payment-summary [selectOrder]="order"></rcyl-payment-summary>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ion-item
            color="medium"
            lines="none"
            (click)="toggleStatusFlow()"
            class="status-section"
          >
            <ion-text color="light" class="section-title">Status Flow</ion-text>
            <ion-icon
              color="light"
              class="ion-no-margin"
              [name]="showStatusFlow == true ? 'remove' : 'add'"
              slot="end"
            ></ion-icon>
          </ion-item>
        </ion-col>
        <ion-col size="12" *ngIf="showStatusFlow" style="overflow: scroll">
          <ion-grid>
            <ion-row>
              <ion-col size="11" class="ion-margin-start">
                <rcyl-status-flow
                  [isSaleOrder]="this.order?.saleOrder"
                  [statusFlow]="statusFlow"
                ></rcyl-status-flow>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="order?.orderType !== 'DROP'" class="ion-padding-top">
        <ion-col size="12">
          <ion-item color="medium" lines="none" class="status-section">
            <ion-text color="light" class="section-title"
              >Transporter and Vehicle Details</ion-text
            >
            <ion-button
              *ngIf="!orderLogisticsDetails && !ifPickedState"
              fill="clear"
              color="light"
              class="status-btn ion-margin-start"
              (click)="addTransportDetailsModal()"
            >
              <ion-icon name="add" color="light"></ion-icon>
              <ion-text class="text-medium" color="light">Add</ion-text>
            </ion-button>
            <ion-icon
              *ngIf="orderLogisticsDetails && !ifPickedState"
              name="create"
              class="ion-margin-start icon-size"
              color="light"
              (click)="addTransportDetailsModal()"
            ></ion-icon>
            <ion-icon
              color="light"
              (click)="transportDetailsFlow()"
              class="ion-no-margin"
              [name]="transportFlowToggle == true ? 'remove' : 'add'"
              slot="end"
            ></ion-icon>
          </ion-item>
        </ion-col>
        <ion-col size="12" no-padding *ngIf="transportFlowToggle">
          <rcyl-transporter-vehicle-details
            [enableEdit]="false"
            [orderLogisticsDetails]="orderLogisticsDetails"
          ></rcyl-transporter-vehicle-details>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="order?.orderType !== 'DROP'">
        <ion-col size="12">
          <ion-item color="medium" lines="none" class="status-section">
            <ion-text color="light" class="section-title"
              >Driver Information
            </ion-text>
            <ion-button
              *ngIf="!orderLogisticsDetails && !ifPickedState"
              fill="clear"
              color="light"
              class="status-btn ion-margin-start"
              (click)="addTransportDetailsModal()"
            >
              <ion-icon name="add" color="light"></ion-icon>
              <ion-text class="text-medium" color="light">Add</ion-text>
            </ion-button>

            <ion-icon
              *ngIf="orderLogisticsDetails && !ifPickedState"
              name="create"
              class="ion-margin-start icon-size"
              color="light"
              (click)="addTransportDetailsModal()"
            ></ion-icon>
            <ion-icon
              color="light"
              (click)="driverDetailsFlow()"
              class="ion-no-margin"
              [name]="driverFlowToggle == true ? 'remove' : 'add'"
              slot="end"
            ></ion-icon>
          </ion-item>
        </ion-col>
        <ion-col size="12" no-padding *ngIf="driverFlowToggle">
          <rcyl-driver-details
            [enableEdit]="false"
            [orderLogisticsDetails]="orderLogisticsDetails"
          ></rcyl-driver-details>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item lines="none">
            <ion-text class="section-title ion-margin-end">Notes</ion-text>
            <br />
            <rcyl-add-notes-button
              [orderId]="this.orderId"
              (noteOutput)="receivedData($event)"
            ></rcyl-add-notes-button>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <rcyl-notes-details [notes]="getNotes"></rcyl-notes-details>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>
  <ng-template [ngSwitchCase]="'RECYKAL'">
    <div class="recykal-app" *ngIf="platform.is('mobile')">
      <div
        *ngIf="componentConfig.channelName == 'B2B'"
        class="non-market-order"
      >
        <!-- generator mobile view start -->
        <div *ngIf="order && order.id" class="mobile-view">
          <div text-center margin class="statusLabel">
            <ion-badge
              font-size-12
              font-bold
              text-wrap
              (click)="getOrderDetails()"
              [OrderStatus]="
                order?.status === 'ORDER_COMPLETED'
                  ? order?.payment?.orderPaymentStatus
                  : order?.status
              "
            >
              <!-- {{  | uppercase}}-->
              {{
                (order.status === "ORDER_COMPLETED"
                  ? order?.payment?.statusTitle
                  : order?.displayStatusTitle
                ) | uppercase
              }}
            </ion-badge>
          </div>
          <div text-center="">
            <ion-text font-regular="" color="medium">
              <span font-size-12="" *ngIf="order.status === 'CREATED'"
                >Your request is being processed</span
              >
              <span font-size-12="" *ngIf="order.status === 'PICKUP_SCHEDULED'"
                >Pickup executive assigned</span
              >
              <span font-size-12="" *ngIf="order.status === 'MATERIAL_PICKED'"
                >Materials have been picked by our executive.</span
              >
              <span
                font-size-12=""
                *ngIf="
                  order.status === 'ORDER_COMPLETED' &&
                  order?.payment?.orderPaymentStatus === 'INVOICE_PENDING'
                "
                >Upload your invoice to get the payment processed</span
              >
            </ion-text>
          </div>
          <ion-grid no-padding="">
            <div
              text-center=""
              *ngIf="
                status(['ORDER_COMPLETED'], true) &&
                order?.payment?.orderPaymentStatus != 'COMPLETED'
              "
            >
              <ion-text font-regular="" color="medium">
                <span font-size-10=""
                  >Please refer to the Proforma Invoice for the net receivable
                  amount.</span
                >
              </ion-text>
            </div>
          </ion-grid>

          <ion-card no-padding no-box-shadow>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <div font-medium="">
                    <ion-text font-size-12="">Pickup Date</ion-text>
                  </div>
                  <div font-size-14 font-medium text-black no-margin>
                    <ion-text>
                      {{ order?.orderDate | date: "dd MMM yyyy" }}
                    </ion-text>
                  </div>
                  <div margin-top-5 font-medium="">
                    <ion-text font-size-12="">Pickup Location</ion-text>
                  </div>
                  <div font-size-14 font-medium text-black no-margin>
                    <ion-text
                      >{{ order?.seller?.name }},
                      {{ order?.fromLocation?.addressInfo | address }}</ion-text
                    >
                  </div>
                  <div class="partner-name">
                    <span>Partner</span>
                    <ion-text text-regular="">
                      • {{ order?.buyer?.name || "-" }}</ion-text
                    >
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
          <ion-card
            no-padding
            no-box-shadow
            *ngIf="
              order?.pickupPerson?.id && status(['ORDER_COMPLETED'], false)
            "
          >
            <ion-grid>
              <ion-row>
                <ion-col>
                  <div>
                    <ion-text font-medium font-size-12>Pickup Person</ion-text>
                  </div>
                  <div>
                    <ion-text text-right="" text-black="" font-medium>{{
                      order?.pickupPerson?.userName
                    }}</ion-text>
                  </div>
                </ion-col>
                <ion-col
                  text-end=""
                  align-items-end=""
                  d-flex=""
                  justify-content-end=""
                >
                  <div
                    *ngIf="order?.pickupPerson?.mobileNumber"
                    (click)="callPickUpPerson(order.pickupPerson.mobileNumber)"
                  >
                    <ion-text text-right="" text-black="" font-medium>
                      <ion-icon name="call" font-size-12></ion-icon>
                      + {{ order?.pickupPerson?.mobileNumber }}
                    </ion-text>
                  </div>
                  <div *ngIf="!order?.pickupPerson?.mobileNumber">-</div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
          <ion-card
            no-padding
            no-box-shadow
            *ngIf="order.payment && order.payment?.paymentSettlement"
          >
            <ion-grid>
              <ion-row>
                <ion-col no-padding-bottom>
                  <div>
                    <ion-text font-medium font-size-12
                      >Payment Details</ion-text
                    >
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <div>
                    <ion-text font-size-12 color="medium">
                      Reference No.
                    </ion-text>
                  </div>
                  <div>
                    <ion-text text-right="" text-black="" font-medium>
                      {{
                        order.payment?.paymentSettlement?.referenceNumber || "-"
                      }}
                    </ion-text>
                  </div>
                </ion-col>
                <ion-col text-end="">
                  <div>
                    <ion-text font-size-12 color="medium">
                      Payment Date
                    </ion-text>
                  </div>
                  <div>
                    <ion-text text-right="" text-black="" font-medium>
                      {{
                        order.payment?.paymentSettlement?.paymentDate
                          | date: "dd MMM yyyy"
                      }}
                    </ion-text>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>

          <ion-card
            no-padding
            no-box-shadow
            *ngIf="
              (order?.orderType === 'DROP' &&
                order?.status === 'PICKUP_SCHEDULED') ||
              order?.status === 'ORDER_COMPLETED' ||
              order?.documents?.length > 0
            "
          >
            <ion-item
              lines="none"
              detail="true"
              (click)="openDocumentManager()"
            >
              <ion-label color="dark" font-bold="">
                Invoices & Documents
              </ion-label>
            </ion-item>
          </ion-card>
          <ion-grid
            no-padding
            *ngIf="orderLogisticsDetails"
            class="transportation-and-vehicle-details"
          >
            <ion-row no-padding>
              <ion-col size="12" no-padding>
                <rcyl-transporter-vehicle-details
                  [enableEdit]="false"
                  [orderStatusLogs]="statusFlow"
                  [orderLogisticsDetails]="orderLogisticsDetails"
                ></rcyl-transporter-vehicle-details>
              </ion-col>
              <ion-col size="12" no-padding>
                <rcyl-driver-details
                  [enableEdit]="false"
                  [orderStatusLogs]="statusFlow"
                  [orderLogisticsDetails]="orderLogisticsDetails"
                ></rcyl-driver-details>
              </ion-col>
            </ion-row>
          </ion-grid>

          <div
            *ngIf="
              (order?.orderItems | rcylFilter: 'tradeType':'S')?.length > 0
            "
          >
            <div margin-top>
              <p class="summary-title">
                <span>ITEMS SUMMARY</span>
              </p>
            </div>
            <ion-card
              no-padding
              no-box-shadow
              *ngFor="
                let oItem of order?.orderItems | rcylFilter: 'tradeType':'B'
              "
            >
              <ion-grid no-padding="">
                <ion-row no-padding="">
                  <ion-col size="4" align-self-center>
                    <div d-flex justify-content-center align-items-center>
                      <ion-img
                        style="width: 30px; margin-right: 10px"
                        [src]="oItem.item.icon"
                      ></ion-img>
                    </div>
                    <div text-center line-height-12>
                      <ion-text text-black font-size-12 font-medium>{{
                        oItem?.item.name
                      }}</ion-text>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center class="item-left-border">
                    <div>
                      <div line-height-10>
                        <ion-text color="medium" font-size-12
                          >Initial Weight</ion-text
                        >
                      </div>
                      <div>
                        <ion-text text-black font-medium font-size-12
                          >{{ oItem?.qty }}
                          {{ oItem.item.unitType | titlecase }}</ion-text
                        >
                      </div>
                    </div>
                    <div
                      *ngIf="
                        status(
                          [
                            'MATERIAL_PICKED',
                            'MATERIAL_RECEIVED',
                            'ORDER_COMPLETED'
                          ],
                          true
                        )
                      "
                    >
                      <div>
                        <ion-text color="medium" font-size-12
                          >Picked Weight</ion-text
                        >
                      </div>
                      <div line-height-10>
                        <ion-text
                          text-black
                          color="primary"
                          font-medium
                          font-size-12
                          >{{ oItem?.formattedVerifyQty }}</ion-text
                        >
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center>
                    <div class="item-total-section">
                      <div>
                        <div line-height-10 d-flex="" align-items-center>
                          <ion-text font-size-12 color="primary"
                            >You earn</ion-text
                          >
                        </div>
                        <div>
                          <ion-text text-black font-medium font-size-12
                            >{{ oItem?.itemPrice | currency: "INR" }}/{{
                              oItem.item.unitType | titlecase
                            }}</ion-text
                          >
                        </div>
                      </div>
                      <div margin-top-5>
                        <div>
                          <ion-text font-size-12 color="primary"
                            >Total earning</ion-text
                          >
                        </div>
                        <div line-height-10>
                          <ion-text text-black font-medium font-size-12>{{
                            oItem?.verifiedAmount | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>
            <ion-card
              no-padding
              no-box-shadow
              *ngFor="
                let oItem of order?.orderItems | rcylFilter: 'tradeType':'S'
              "
            >
              <ion-grid no-padding="">
                <ion-row no-padding="">
                  <ion-col size="4" align-self-center>
                    <div d-flex justify-content-center align-items-center>
                      <ion-img
                        style="width: 30px; margin-right: 10px"
                        [src]="oItem.item.icon"
                      ></ion-img>
                    </div>
                    <div text-center line-height-12>
                      <ion-text text-black font-size-12 font-medium>{{
                        oItem?.item.name
                      }}</ion-text>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center class="item-left-border">
                    <div>
                      <div line-height-10>
                        <ion-text color="medium" font-size-12
                          >Initial Weight</ion-text
                        >
                      </div>
                      <div>
                        <ion-text text-black font-medium font-size-12
                          >{{ oItem?.qty }}
                          {{ oItem.item.unitType | titlecase }}</ion-text
                        >
                      </div>
                    </div>
                    <div
                      *ngIf="
                        status(
                          [
                            'MATERIAL_PICKED',
                            'MATERIAL_RECEIVED',
                            'ORDER_COMPLETED'
                          ],
                          true
                        )
                      "
                    >
                      <div>
                        <ion-text color="medium" font-size-12
                          >Picked Weight</ion-text
                        >
                      </div>
                      <div line-height-10>
                        <ion-text
                          text-black
                          color="primary"
                          font-medium
                          font-size-12
                          >{{ oItem?.formattedVerifyQty }}</ion-text
                        >
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center>
                    <div class="item-total-section">
                      <div>
                        <div line-height-10 d-flex="" align-items-center>
                          <ion-text font-size-12 color="danger"
                            >Service fee</ion-text
                          >
                        </div>
                        <div>
                          <ion-text text-black font-medium font-size-12
                            >{{ oItem?.itemPrice | currency: "INR" }}/{{
                              oItem.item.unitType | titlecase
                            }}</ion-text
                          >
                        </div>
                      </div>
                      <div margin-top-5>
                        <div>
                          <ion-text font-size-12 color="danger"
                            >Total fee to pay</ion-text
                          >
                        </div>
                        <div line-height-10>
                          <ion-text text-black font-medium font-size-12>{{
                            oItem?.verifiedAmount | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>
            <div margin-top>
              <p class="summary-title"><span>TOTALS</span></p>
            </div>
            <ion-grid no-padding>
              <ion-row no-padding>
                <ion-col size="12" no-padding>
                  <ion-card no-padding no-box-shadow style="margin-bottom: 0">
                    <ion-grid>
                      <ion-row>
                        <ion-col size="8" no-padding-bottom>
                          <ion-text font-size-12 color="medium"
                            >Total Initial Weight</ion-text
                          >
                        </ion-col>
                        <ion-col size="4" text-end no-padding-bottom>
                          <ion-text font-size-12 color="dark">
                            {{ order?.totalInitialQty }} Qty
                          </ion-text>
                        </ion-col>
                      </ion-row>
                      <ion-row
                        *ngIf="
                          status(
                            [
                              'MATERIAL_PICKED',
                              'MATERIAL_RECEIVED',
                              'ORDER_COMPLETED'
                            ],
                            true
                          )
                        "
                      >
                        <ion-col size="8">
                          <ion-text font-size-12 color="medium">
                            Total Picked Weight
                          </ion-text>
                        </ion-col>
                        <ion-col size="4" text-end>
                          <ion-text font-bold="" font-size-12 color="dark">
                            {{ order?.totalPickedQty }} Qty
                          </ion-text>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-card>
                </ion-col>

                <ion-col size="12" no-padding>
                  <ion-card no-padding no-box-shadow>
                    <ion-grid>
                      <ion-row>
                        <ion-col size="8" no-padding-bottom>
                          <ion-text font-size-12 color="medium"
                            >Amount you earn</ion-text
                          >
                        </ion-col>
                        <ion-col size="4" text-end no-padding-bottom>
                          <ion-text font-size-12 color="primary">
                            {{ order.totalAmount | currency: "INR"
                            }}<span *ngIf="!status(['ORDER_COMPLETED'], true)"
                              >*</span
                            >
                          </ion-text>
                        </ion-col>
                        <ion-col size="8">
                          <ion-text font-size-12 color="medium"
                            >Service fee you pay</ion-text
                          >
                        </ion-col>
                        <ion-col size="4" text-end>
                          (-)
                          <ion-text font-size-12 color="danger">
                            {{ order.totalEarnAmount | currency: "INR"
                            }}<span *ngIf="!status(['ORDER_COMPLETED'], true)"
                              >*</span
                            >
                          </ion-text>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="!status(['ORDER_COMPLETED'], true)">
                        <ion-col size="8">
                          <ion-text font-size-12 color="medium">
                            <span *ngIf="order.totalAmountOfExclTax >= 0"
                              >Estimated final amount that you earn</span
                            >
                            <span *ngIf="order.totalAmountOfExclTax < 0"
                              >Estimated final amount that you pay</span
                            >
                          </ion-text>
                        </ion-col>
                        <ion-col size="4" text-end>
                          <ion-text
                            font-size-12
                            [color]="
                              order.totalAmountOfExclTax >= 0
                                ? 'primary'
                                : 'danger'
                            "
                          >
                            {{
                              getAbs(order.totalAmountOfExclTax)
                                | currency: "INR"
                            }}*
                          </ion-text>
                        </ion-col>
                        <ion-col size="12">
                          <ion-text font-size-12
                            ><i>*All rates exclusive of GST</i></ion-text
                          >
                        </ion-col>
                      </ion-row>

                      <ion-row *ngIf="status(['ORDER_COMPLETED'], true)">
                        <ion-col size="8">
                          <ion-text font-size-12 color="medium">
                            GST Applicable
                          </ion-text>
                        </ion-col>
                        <ion-col size="4" text-end>
                          <span *ngIf="order?.totalOfAllTaxes < 0">(-) </span>
                          <ion-text
                            font-size-12
                            [color]="
                              order?.totalOfAllTaxes >= 0 ? 'primary' : 'danger'
                            "
                          >
                            {{
                              getAbs(order?.totalOfAllTaxes) | currency: "INR"
                            }}
                          </ion-text>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="status(['ORDER_COMPLETED'], true)">
                        <ion-col size="8">
                          <ion-text font-size-12 color="medium">
                            <span *ngIf="order?.tradeType === 'B'"
                              >Net amount that you earn</span
                            >
                            <span *ngIf="order?.tradeType === 'S'"
                              >Net amount that you pay</span
                            >
                          </ion-text>
                        </ion-col>
                        <ion-col size="4" text-end>
                          <ion-text
                            font-size-12
                            [color]="
                              order?.tradeType === 'B' ? 'primary' : 'danger'
                            "
                            font-bold=""
                          >
                            {{ order.netAmount | currency: "INR" }}*
                          </ion-text>
                        </ion-col>
                        <ion-col size="12">
                          <ion-text font-size-12
                            ><i>*Net amount is inclusive of taxes</i></ion-text
                          >
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-card>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>

          <div
            *ngIf="
              (order?.orderItems | rcylFilter: 'tradeType':'S')?.length <= 0
            "
          >
            <div>
              <p class="summary-title"><span>YOUR SUMMARY</span></p>
            </div>
            <ion-card
              no-padding
              no-box-shadow
              *ngFor="let oItem of order?.orderItems"
            >
              <ion-grid no-padding="">
                <ion-row no-padding="">
                  <ion-col size="4" align-self-center>
                    <div d-flex justify-content-center align-items-center>
                      <ion-img
                        style="width: 30px; margin-right: 10px"
                        [src]="oItem.item.icon"
                      ></ion-img>
                    </div>
                    <div text-center line-height-12>
                      <ion-text text-black font-size-12 font-medium>{{
                        oItem?.item.name
                      }}</ion-text>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center class="item-left-border">
                    <div>
                      <div line-height-10>
                        <ion-text color="medium" font-size-12
                          >Initial Weight</ion-text
                        >
                      </div>
                      <div>
                        <ion-text text-black font-medium font-size-12
                          >{{ oItem?.qty }}
                          {{ oItem.item.unitType | titlecase }}</ion-text
                        >
                      </div>
                    </div>
                    <div
                      *ngIf="
                        status(
                          [
                            'MATERIAL_PICKED',
                            'MATERIAL_RECEIVED',
                            'ORDER_COMPLETED'
                          ],
                          true
                        )
                      "
                    >
                      <div>
                        <ion-text color="medium" font-size-12
                          >Picked Weight</ion-text
                        >
                      </div>
                      <div line-height-10>
                        <ion-text
                          text-black
                          color="primary"
                          font-medium
                          font-size-12
                          >{{ oItem?.formattedVerifyQty }}</ion-text
                        >
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center>
                    <div class="item-total-section">
                      <div>
                        <div line-height-10>
                          <ion-text font-size-12
                            >Price Per
                            {{ oItem.item.unitType | titlecase }}</ion-text
                          >
                        </div>
                        <div>
                          <ion-text text-black font-medium font-size-12>{{
                            oItem?.itemPrice | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                      <div margin-top-5>
                        <div>
                          <ion-text font-size-12>Total Value</ion-text>
                        </div>
                        <div line-height-10>
                          <ion-text text-black font-medium font-size-12>{{
                            oItem?.verifiedAmount | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>

            <ion-card no-padding no-box-shadow>
              <ion-grid no-padding="">
                <ion-row no-padding="">
                  <ion-col size="4" align-self-center>
                    <div text-center line-height-12>
                      <ion-text text-black style="font-size: 18px" text-bold
                        >Totals</ion-text
                      >
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center class="item-left-border">
                    <div>
                      <div line-height-10>
                        <ion-text color="medium" font-size-12
                          >Total Initial</ion-text
                        >
                      </div>
                      <div>
                        <ion-text text-black font-medium font-size-12
                          >{{ order?.totalInitialQty }} Qty</ion-text
                        >
                      </div>
                    </div>
                    <div
                      margin-top-5
                      *ngIf="
                        status(
                          [
                            'MATERIAL_PICKED',
                            'MATERIAL_RECEIVED',
                            'ORDER_COMPLETED'
                          ],
                          true
                        )
                      "
                    >
                      <div line-height-10>
                        <ion-text color="medium" font-size-12
                          >Total Picked</ion-text
                        >
                      </div>
                      <div>
                        <ion-text
                          text-black
                          color="primary"
                          font-medium
                          font-size-12
                          >{{ order?.totalPickedQty }} Qty</ion-text
                        >
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4" align-self-center>
                    <div class="order-total-section">
                      <div>
                        <div line-height-10>
                          <ion-text font-size-12 color="light">Total</ion-text>
                        </div>
                        <div>
                          <ion-text color="light" font-medium font-size-12>{{
                            order.totalAmount | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                      <div
                        margin-top-5
                        *ngIf="
                          order?.gstOrder && status(['ORDER_COMPLETED'], true)
                        "
                      >
                        <div>
                          <ion-text font-size-12 color="light">GST</ion-text>
                        </div>
                        <div line-height-10>
                          <ion-text color="light" font-medium font-size-12>{{
                            order.totalTax | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                      <div
                        margin-top-5
                        *ngIf="status(['ORDER_COMPLETED'], true)"
                      >
                        <div>
                          <ion-text font-size-12 color="light"
                            >Total Payable</ion-text
                          >
                        </div>
                        <div line-height-10>
                          <ion-text color="light" font-medium font-size-12>{{
                            order?.netAmount | currency: "INR"
                          }}</ion-text>
                        </div>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>
            <div
              text-center=""
              *ngIf="status(['ORDER_COMPLETED'], true) && order?.gstOrder"
            >
              <ion-text
                font-regular=""
                style="font-style: italic"
                [color]="'medium'"
                font-size-12=""
                >Note • Total Payable amount is inclusive of taxes
              </ion-text>
            </div>
          </div>

          <!--<ion-card no-padding no-box-shadow >
                        <ion-grid no-padding="">
                            <ion-row no-padding="" >
                                <ion-col size="4"  align-self-center >
                                    <div text-center line-height-12 >
                                        <ion-text text-black style="font-size:18px" text-bold >Totals</ion-text>
                                    </div>
                                </ion-col>
                                <ion-col size="4" align-self-center class="item-left-border">
                                    <div>
                                        <div line-height-10>
                                            <ion-text color="medium" font-size-12 >Total Initial</ion-text>
                                        </div>
                                        <div>
                                            <ion-text text-black font-medium font-size-12>{{totalInitialQty}} Qty</ion-text>
                                        </div>
                                    </div>
                                    <div margin-top-5 *ngIf="status(['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)">
                                        <div line-height-10>
                                            <ion-text color="medium" font-size-12 >Total Picked</ion-text>
                                        </div>
                                        <div>
                                            <ion-text text-black color="primary" font-medium font-size-12>{{  order.status === 'ORDER_COMPLETED' ? totalReceivedQty : totalPickedQty }} Qty</ion-text>
                                        </div>
                                    </div>
                                </ion-col>
                                <ion-col size="4" align-self-center>
                                    <div class="order-total-section">
                                        <div>
                                            <div line-height-10>
                                                <ion-text font-size-12 color="light"  >Price to earn</ion-text>
                                            </div>
                                            <div>
                                                <ion-text color="light" font-medium font-size-12>{{ order.totalAmount | currency: 'INR'}}</ion-text>
                                            </div>
                                        </div>
                                        <div margin-top-5="">
                                            <div line-height-10>
                                                <ion-text font-size-12 color="light"  >Price to pay</ion-text>
                                            </div>
                                            <div>
                                                <ion-text color="light" font-medium font-size-12>{{ order.totalEarnAmount | currency: 'INR'}}</ion-text>
                                            </div>
                                        </div>
                                        <div margin-top-5 *ngIf="order?.gstOrder && status(['ORDER_COMPLETED'], true)">
                                            <div>
                                                <ion-text font-size-12 color="light" >GST</ion-text>
                                            </div>
                                            <div line-height-10>
                                                <ion-text  color="light" font-medium font-size-12>{{ order.totalTax | currency: 'INR'}}</ion-text>
                                            </div>
                                        </div>
                                        <div margin-top-5 *ngIf="status(['ORDER_COMPLETED'], true)">
                                            <div>
                                                <ion-text font-size-12 color="light" >Total Payable</ion-text>
                                            </div>
                                            <div line-height-10>
                                                <ion-text color="light" font-medium font-size-12>{{ order?.netAmount | currency: 'INR'}}</ion-text>
                                            </div>
                                        </div>
                                    </div>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>-->

          <ion-grid no-padding="" *ngIf="order?.allowEdit">
            <ion-row>
              <ion-col size="6" no-padding-left>
                <ion-button
                  expand="block"
                  no-padding
                  color="light"
                  (click)="loadTimeSlot()"
                  class="orderActionBtns"
                  font-medium
                  text-black
                >
                  <ion-icon size="small" name="time"></ion-icon>&nbsp;Reschedule
                </ion-button>
              </ion-col>
              <ion-col size="6" no-padding-right>
                <ion-button
                  expand="block"
                  no-padding
                  color="light"
                  (click)="openCancelPickupOrderDailog()"
                  class="orderActionBtns"
                  font-medium
                  text-black
                >
                  <ion-icon name="close" mode="ios"></ion-icon>&nbsp;Cancel
                  Order
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        <a class="download-zip-link" #downloadZipLink></a>
        <!-- generator mobile view end -->
      </div>
    </div>
    <div class="recykal-app" *ngIf="!platform.is('mobile') && order">
      <ion-row>
        <!--<ion-col size="12">
                    <ion-icon [src]="'./assets/paper.svg'" style="font-size:18px;" ></ion-icon>
                    <ion-text font-bold="" text-large="">{{order?.formattedId}}</ion-text>
                </ion-col>-->
        <ion-col size="4">
          <ion-card
            color="light"
            class="my-item ion-no-margin"
            style="height: 100%"
          >
            <ion-grid class="ion-no-padding">
              <ion-row class="ion-padding-horizontal">
                <ion-col size="12" style="padding-bottom: 0">
                  <ion-text color="medium" class="label"
                    >Customer Details</ion-text
                  >
                </ion-col>
                <ion-col size="12">
                  <ion-text
                    class="text-medium font-bold"
                    font-bold
                    color="dark"
                    >{{ order?.seller?.name }}</ion-text
                  >
                  <div style="line-height: 17px" *ngIf="order?.fromLocation">
                    <ion-text
                      [pTooltip]="order?.fromLocation?.addressInfo | address"
                      tooltipStyleClass="tooltip-bg-white"
                      color="medium"
                      class="text-regular address-box line-2"
                      margin-bottom
                      >{{
                        order?.fromLocation?.addressInfo | address
                      }}</ion-text
                    >
                  </div>
                </ion-col>
                <ion-col size="12">
                  <ion-text color="dark"
                    >Partner name • {{ order?.buyer?.name }}</ion-text
                  >
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
        </ion-col>
        <ion-col size="4">
          <ion-card
            color="light"
            class="my-item ion-no-margin"
            style="height: 100%"
          >
            <ion-grid *ngIf="order" class="ion-no-padding">
              <ion-row class="ion-padding-horizontal">
                <ion-col size="12" *ngIf="order?.pickupPerson">
                  <ion-text color="medium" class="label">Pickup Person</ion-text
                  ><br />
                  <div class="person-details">
                    <ion-icon
                      name="contact"
                      class="icon-padding"
                      color="dark"
                    ></ion-icon>
                    <ion-text color="dark" class="font-bold" font-bold>{{
                      order?.pickupPerson?.userName
                    }}</ion-text>
                  </div>
                </ion-col>
                <ion-col size="12">
                  <ion-text color="medium" class="label">Pickup Date</ion-text>
                  <br />
                  <ion-text color="dark"
                    >{{
                      order?.timeSlot?.startTime
                        | date: "dd-MMM-yy hh:mm a" || "---"
                    }}
                  </ion-text>
                </ion-col>
                <ion-col size="12">
                  <ion-text color="medium" class="label">Created on</ion-text>
                  <br />
                  <ion-text color="dark">{{
                    order?.createdDate | date: "dd-MMM-yy hh:mm a" || "---"
                  }}</ion-text>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
        </ion-col>
        <ion-col size="4">
          <ion-card
            color="light"
            class="my-item ion-no-margin"
            style="height: 100%"
          >
            <ion-grid *ngIf="order" class="ion-no-padding">
              <ion-row class="ion-padding-horizontal parent-class">
                <ion-col>
                  <ion-row
                    [ngClass]="{ 'status-area': order?.status !== 'CANCELLED' }"
                  >
                    <ion-col size="12" class="ion-no-padding">
                      <ion-text color="medium" class="label">Status</ion-text>
                    </ion-col>
                    <ion-col size="12" class="ion-no-padding status-icons">
                      <div>
                        <ion-icon
                          [src]="'./assets/MATERIAL_RECEIVED.svg'"
                          *ngIf="
                            order?.saleOrder &&
                            order?.status === 'PICKUP_SCHEDULED'
                          "
                        ></ion-icon>
                        <ion-icon
                          [src]="'./assets/REJECTED.svg'"
                          *ngIf="
                            order?.payment?.orderPaymentStatus ===
                              'INVOICE_REJECTED' &&
                            order?.status === 'ORDER_COMPLETED'
                          "
                        ></ion-icon>
                        <ion-icon
                          [src]="'./assets/INVOICE_PENDING.svg'"
                          *ngIf="
                            order?.payment?.orderPaymentStatus ===
                              'INVOICE_VERIFICATION_PENDING' &&
                            order?.status === 'ORDER_COMPLETED'
                          "
                        ></ion-icon>
                        <ion-icon
                          [src]="'./assets/' + order?.status + '.svg'"
                          [ngClass]="{
                            'reject-icon': order?.status === 'CANCELLED'
                          }"
                          *ngIf="
                            order?.status !== 'ORDER_COMPLETED' &&
                            order?.status != 'HOLD' &&
                            order?.status != 'AWAITING_PICKUP_CONFIRMATION'
                          "
                        ></ion-icon>
                        <ion-icon
                          [src]="
                            './assets/' +
                            order?.payment?.orderPaymentStatus +
                            '.svg'
                          "
                          *ngIf="
                            order?.payment?.orderPaymentStatus !==
                              'INVOICE_REJECTED' &&
                            order?.status === 'ORDER_COMPLETED' &&
                            order?.payment?.orderPaymentStatus !==
                              'INVOICE_VERIFICATION_PENDING'
                          "
                        ></ion-icon>
                        <ion-text
                          class="status"
                          color="dark"
                          *ngIf="
                            order?.status !== 'ORDER_COMPLETED' &&
                            order?.status !== 'AWAITING_PICKUP_CONFIRMATION'
                          "
                          >{{ order?.displayStatusTitle }}</ion-text
                        >
                        <ion-text
                          class="status"
                          color="dark"
                          *ngIf="
                            order?.status !== 'ORDER_COMPLETED' &&
                            order?.status === 'AWAITING_PICKUP_CONFIRMATION'
                          "
                          >{{ order?.statusTitle }}</ion-text
                        >
                        <ion-text
                          class="status ion-text-capitalize"
                          color="dark"
                          *ngIf="order?.status === 'ORDER_COMPLETED'"
                          >{{ order?.payment?.statusTitle }}
                        </ion-text>
                      </div>
                      <br />
                      <ion-text
                        color="medium"
                        text-regular=""
                        class="ion-text-capitalize"
                      >
                        <span *ngIf="order.status === 'CREATED'"
                          >Your request is being processed</span
                        >
                        <span
                          font-size-12=""
                          *ngIf="order.status === 'PICKUP_SCHEDULED'"
                          >Pickup executive assigned</span
                        >
                        <span
                          font-size-12=""
                          *ngIf="order.status === 'MATERIAL_PICKED'"
                          >Materials have been picked by our executive.</span
                        >
                        <span
                          font-size-12=""
                          *ngIf="
                            order.status === 'ORDER_COMPLETED' &&
                            order?.payment?.orderPaymentStatus ===
                              'INVOICE_PENDING'
                          "
                          >Upload your invoice to get the payment
                          processed</span
                        >
                        <span
                          font-size-12=""
                          color="medium"
                          text-small
                          font-bold
                          class="ion-text-uppercase label"
                          *ngIf="
                            order?.status === 'ORDER_COMPLETED' &&
                            order?.payment?.orderPaymentStatus ===
                              'INVOICE_REJECTED'
                          "
                          >Reason</span
                        >
                        <br />
                        <span
                          font-size-12=""
                          *ngIf="
                            order?.status === 'ORDER_COMPLETED' &&
                            order?.payment?.orderPaymentStatus ===
                              'INVOICE_REJECTED'
                          "
                          >{{ invoiceRejectedObj?.comment }}</span
                        >
                        <span
                          font-size-12=""
                          color="medium"
                          text-small
                          font-bold
                          class="ion-text-uppercase label"
                          *ngIf="
                            order?.status === 'CANCELLED' ||
                            order?.status === 'HOLD'
                          "
                          >Reason</span
                        >
                        <br />
                        <span
                          font-size-12=""
                          *ngIf="
                            order?.status === 'CANCELLED' ||
                            order?.status === 'HOLD'
                          "
                          >{{ order?.rejectionReason }}</span
                        >
                      </ion-text>
                    </ion-col>
                  </ion-row>
                  <ion-row margin-top *ngIf="order?.allowEdit">
                    <!--   Quick Actions   -->
                    <ion-col size="12" class="ion-no-padding quick-actions">
                      <ion-text color="medium" class="label"
                        >Quick Actions</ion-text
                      >
                      <div>
                        <ion-button
                          class="ion-text-uppercase status-btn"
                          [color]="'medium'"
                          (click)="loadTimeSlot()"
                        >
                          <ion-icon
                            name="refresh"
                            color="light"
                            class="ion-float-left icon-padding"
                          ></ion-icon>
                          Reschedule</ion-button
                        >
                        <ion-button
                          [color]="'danger'"
                          (click)="openCancelPickupOrderDailog()"
                          class="status-btn ion-text-uppercase"
                        >
                          <ion-icon
                            name="close"
                            color="light"
                            class="ion-float-left icon-padding"
                          ></ion-icon>
                          CANCEL
                        </ion-button>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>
        <!--  desktop order items -->
        <ion-col size="12">
          <ion-item lines="none">
            <ion-text class="section-title ion-margin-end"
              >Item Details</ion-text
            >
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <rcyl-item-details
            [selectOrder]="order"
            [channel]="orderConfig?.channel"
            (itemUpdated)="onItemChanged($event)"
          ></rcyl-item-details>
        </ion-col>
        <!--  desktop order summary -->
        <ion-col size="12">
          <ion-grid no-padding>
            <ion-row no-padding>
              <ion-col size="12" no-padding>
                <ion-card
                  color="light"
                  class="ion-no-margin"
                  style="box-shadow: none; background: #f4f9fa"
                >
                  <ion-grid>
                    <ion-row>
                      <ion-col
                        size="8"
                        no-padding-bottom
                        *ngIf="order?.totalEarnAmount > 0"
                      >
                        <ion-text font-size-12 color="medium"
                          >Amount you earn</ion-text
                        >
                      </ion-col>
                      <ion-col
                        size="4"
                        text-end
                        no-padding-bottom
                        *ngIf="order?.totalEarnAmount > 0"
                      >
                        <ion-text font-size-12 color="primary">
                          {{ order.totalAmount | currency: "INR"
                          }}<span *ngIf="!status(['ORDER_COMPLETED'], true)"
                            >*</span
                          >
                        </ion-text>
                      </ion-col>
                      <ion-col size="8" *ngIf="order?.totalEarnAmount > 0">
                        <ion-text font-size-12 color="medium"
                          >Service fee you pay</ion-text
                        >
                      </ion-col>
                      <ion-col
                        size="4"
                        text-end
                        *ngIf="order?.totalEarnAmount > 0"
                      >
                        (-)
                        <ion-text font-size-12 color="danger">
                          {{ order.totalEarnAmount | currency: "INR"
                          }}<span *ngIf="!status(['ORDER_COMPLETED'], true)"
                            >*</span
                          >
                        </ion-text>
                      </ion-col>
                    </ion-row>
                    <ion-row *ngIf="!status(['ORDER_COMPLETED'], true)">
                      <ion-col size="8">
                        <ion-text font-size-12 color="medium">
                          <span *ngIf="order.totalAmountOfExclTax >= 0"
                            >Estimated final amount that you earn</span
                          >
                          <span *ngIf="order.totalAmountOfExclTax < 0"
                            >Estimated final amount that you pay</span
                          >
                        </ion-text>
                      </ion-col>
                      <ion-col size="4" text-end>
                        <ion-text
                          font-size-12
                          [color]="
                            order.totalAmountOfExclTax >= 0
                              ? 'primary'
                              : 'danger'
                          "
                        >
                          {{
                            getAbs(order.totalAmountOfExclTax)
                              | currency: "INR"
                          }}*
                        </ion-text>
                      </ion-col>
                      <ion-col size="12">
                        <ion-text font-size-12
                          ><i>*All rates exclusive of GST</i></ion-text
                        >
                      </ion-col>
                    </ion-row>

                    <ion-row *ngIf="status(['ORDER_COMPLETED'], true)">
                      <ion-col size="8">
                        <ion-text font-size-12 color="medium">
                          GST Applicable
                        </ion-text>
                      </ion-col>
                      <ion-col size="4" text-end>
                        <span *ngIf="order?.totalOfAllTaxes < 0">(-) </span>
                        <ion-text
                          font-size-12
                          [color]="
                            order?.totalOfAllTaxes >= 0 ? 'primary' : 'danger'
                          "
                        >
                          {{ getAbs(order?.totalOfAllTaxes) | currency: "INR" }}
                        </ion-text>
                      </ion-col>
                    </ion-row>
                    <ion-row *ngIf="status(['ORDER_COMPLETED'], true)">
                      <ion-col size="8">
                        <ion-text font-size-12 color="medium">
                          <span *ngIf="order?.tradeType === 'B'"
                            >Net amount that you earn</span
                          >
                          <span *ngIf="order?.tradeType === 'S'"
                            >Net amount that you pay</span
                          >
                        </ion-text>
                      </ion-col>
                      <ion-col size="4" text-end>
                        <ion-text
                          font-size-12
                          [color]="
                            order?.tradeType === 'B' ? 'primary' : 'danger'
                          "
                          font-bold=""
                        >
                          {{ order.netAmount | currency: "INR" }}*
                        </ion-text>
                      </ion-col>
                      <ion-col size="12">
                        <ion-text font-size-12
                          ><i>*Net amount is inclusive of taxes</i></ion-text
                        >
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
        <!--  desktop order documents  -->
        <ion-col
          size="12"
          *ngIf="
            order?.status === 'ORDER_COMPLETED' || order?.documents?.length > 0
          "
        >
          <ion-item lines="none">
            <ion-text class="section-title"
              >View/Upload Supporting Documents</ion-text
            >
          </ion-item>
        </ion-col>
        <ion-col
          size="12"
          class="col-position"
          *ngIf="
            (order?.orderType === 'DROP' &&
              order?.status === 'PICKUP_SCHEDULED') ||
            order?.status === 'ORDER_COMPLETED' ||
            order?.documents?.length > 0
          "
        >
          <ion-grid>
            <ion-row>
              <ion-col
                size="auto"
                *ngFor="
                  let orderTypeData of orderDocumentsMap
                    | rcylFilter: 'showInList':true
                    | rcylKeys
                "
              >
                <ion-chip
                  [outline]="true"
                  [ngClass]="
                    orderTypeData?.val?.documents?.length > 0
                      ? 'docs-chip'
                      : 'no-docs-chip'
                  "
                  (click)="addDocuments(orderTypeData?.key)"
                >
                  <ion-icon [src]="orderTypeData?.val?.icon"></ion-icon>
                  <ion-text
                    text-wrap
                    [color]="
                      orderTypeData?.val?.documents?.length > 0
                        ? 'primary'
                        : 'medium'
                    "
                    class="text-regular text-flex"
                  >
                    {{ orderTypeData?.val?.displayText }}
                  </ion-text>
                  <div
                    color="primary"
                    *ngIf="orderTypeData?.val?.documents?.length > 0"
                  >
                    <ion-text class="text-regular" color="light">{{
                      orderTypeData?.val?.documents?.length
                    }}</ion-text>
                  </div>
                </ion-chip>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>

        <!-- payment summary-->
        <ion-col
          size="12"
          *ngIf="
            order?.payment?.orderPaymentStatus === 'COMPLETED' &&
            order?.status === 'ORDER_COMPLETED'
          "
        >
          <ion-item lines="none">
            <ion-text class="section-title ion-margin-end"
              >Payment Summary</ion-text
            >
          </ion-item>
        </ion-col>
        <ion-col
          size="12"
          *ngIf="
            order?.payment?.orderPaymentStatus === 'COMPLETED' &&
            order?.status === 'ORDER_COMPLETED'
          "
        >
          <rcyl-payment-summary
            [channel]="orderConfig?.channel"
            [selectOrder]="order"
          ></rcyl-payment-summary>
        </ion-col>
      </ion-row>
    </div>
  </ng-template>
</div>
